import { ErrorPageDetailsTypes } from '@/types/errorPageDetailsTypes';

export const errorPageDetailsConstant: ErrorPageDetailsTypes = {
  description: 'Oops something went wrong. Please try again in a little while.',
  title: 'System Error',
};
